import React, {Component} from 'react';

class Overlay extends Component {
    sidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
        document.body.classList.toggle('sidebar-mobile-show');
    }

    render() {
        const isAdmin = this.props.isAdmin;

        return (isAdmin) ? null : <div className="overlay-background" onClick={this.sidebarToggle.bind(this)}></div>;
    }
}

export default Overlay;


// WEBPACK FOOTER //
// ./src/components/Sidebar/Overlay.js